import { AdditionalServicesComponent } from './additional-services/additional-services.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { ConnectedAppsComponent } from './connected-apps/connected-apps.component';
import { ConnectModalComponent } from './connect-modal/connect-modal.component';
import { ExportAccountComponent } from './export-account/export-account.component';
import { ExportReportComponent } from './export-report/export-report.component';
import { FutureSolutionsComponent } from './future-solutions/future-solutions.component';
import { HomeComponent } from './home/home.component';
import { LineChartComponent } from './line-chart/line-chart.component';
import { ListChartComponent } from './list-chart/list-chart.component';
import { SliderComponent } from './slider/slider.component';

export const COMPONENTS = [
  AdditionalServicesComponent,
  BarChartComponent,
  ConnectedAppsComponent,
  ConnectModalComponent,
  ExportAccountComponent,
  ExportReportComponent,
  FutureSolutionsComponent,
  HomeComponent,
  LineChartComponent,
  ListChartComponent,
  SliderComponent
];
